const data = {
  api_url: "https://myteambo.myflobot.com/api/",
  flobot_api_url: "https://www.myflobot.com/app/gps_tracker_api.php?request=",
  image_url: "https://myteambo.myflobot.com",
  socket_url: "wss://myteambo.myflobot.com",
  map_icon: "https://www.myflobot.com/GPSTracking/images/ftm.png"
}

export default data;
